import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=2ec51187&scoped=true&"
import script from "./Jobs.vue?vue&type=script&lang=js&"
export * from "./Jobs.vue?vue&type=script&lang=js&"
import style0 from "./Jobs.vue?vue&type=style&index=0&id=2ec51187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec51187",
  null
  
)

export default component.exports